export function isHTMLAnchorElement(el) {
    return el && el.tagName === 'A';
}
